import React, { useRef, useState } from "react";
import { Upload, Check, Loader2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

// Gallery/file upload (allowed for bank proof, payment screenshot, admin QR).
export const FileUploadField = ({ label, purpose, accept = "image/*,application/pdf", onUploaded, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState(null);
  const [done, setDone] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("purpose", purpose);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setName(file.name);
      setDone(true);
      onUploaded(data.file_id, file.name);
      toast.success(`${label} uploaded`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={testId}>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handle} data-testid={`${testId}-input`} />
      <Button type="button" variant="outline" className="w-full justify-start" onClick={() => inputRef.current?.click()} disabled={uploading}>
        {uploading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : done ? <Check className="h-4 w-4 mr-2 text-emerald-600" /> : <Upload className="h-4 w-4 mr-2" />}
        {done ? <span className="truncate flex items-center gap-1"><FileText className="h-3.5 w-3.5" /> {name}</span> : label}
      </Button>
    </div>
  );
};
